export const DEBUG_ACTION_NAME = 'Complete with LLM'
